import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const smartActionsStyles = makeStyles((theme: Theme) =>
  createStyles({
    popup: {
      position: 'absolute',
      display: 'flex',
      flexDirection: 'column',
      top: '5vh',
      left: '5%',
      // bottom: 0,
      width: '90%',
      height: '80vh',
      zIndex: 100,
      // padding: '10px',
      backgroundColor: 'white',
      color: '#000',
      border: '1px solid #000',
      borderRadius: 10,
      boxShadow: '0 0 20px 0 #444',
      overflow: 'hidden',
    },
    flexCol: {
      display: 'flex',
      flexDirection: 'column',
    },
    flexRow: {
      display: 'flex',
      flexDirection: 'row',
    },
    header: {
      width: '100%',
      height: '40px',
      alignItems: 'center',
      // padding: '5px 10px',
      background: '#0F0F0F',
      color: '#FFFFFF',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      '& div': {
        marginLeft: 10,
      },
    },
    input: {
      height: '30px',
    },
    mt1: {
      marginTop: '1rem',
    },
    mb1: {
      marginBottom: '1rem',
    },
    form: {
      width: '500px',
    },
    actionName: {
      marginRight: '1rem',
    },
    policyEntry: {
      height: '30px',
    },
    label: {
      width: '200px',
    },
    value: {
      marginLeft: '1rem',
      width: '200px',
    },
    icon: {
      cursor: 'pointer',
    },
    policyBody: {
      flex: 1,
      flexDirection: 'column',
      height: 'inherit',
      overflow: 'hidden',
      padding: 10,
    },
    content: {
      flex: 1,
      overflow: 'auto',
    },
    footer: {
      display: 'flex',
      flexDirection: 'row-reverse',
      padding: 10,
      '& button': {
        marginLeft: '1rem',
      },
    },
  }),
);

export { smartActionsStyles };
